const config = {
    'links': {
        'socialMedia': {
            'facebook': {
                'title': 'Facebook',
                'href': 'https://www.facebook.com/visit.dresden',
                'icon': 'fab fa-facebook'
            },
            'twitter': {
                'title': 'Twitter',
                'href': 'https://twitter.com/visit_dresden',
                'icon': 'fab fa-twitter'
            },
            'youtube': {
                'title': 'Youtube',
                'href': 'https://www.youtube.com/c/visitdresdennow',
                'icon': 'fab fa-youtube'
            },
            'instagram': {
                'title': 'Instagram',
                'href': 'https://instagram.com/visit.dresden',
                'icon': 'fab fa-instagram'
            }
        },
        'header': {
            'home': {
                'title': 'home',
                'routeName': 'home',
                'isExternal': false
            },
            'events': {
                'title': 'events',
                'routeName': 'events',
                'isExternal': false
            },
            // TODO: Add when custom filter for locations is added for the frontend
            // 'locations': {
            //     'title': 'locations',
            //     'routeName': 'locations',
            //     'isExternal': false
            // },
            'host_area': {
                'title': 'host_area',
                'href': `${window.APP_CONFIG.API_ENTRYPOINT.replace(/\/$/, '')}/admin`,
                'isExternal': true
            },
        },
        'footer': {
            'home': {
                'title': 'home',
                'routeName': 'home',
                'isExternal': false
            },
            'events': {
                'title': 'events',
                'routeName': 'events',
                'isExternal': false
            },
            'contact': {
                'title': 'contact',
                'href': 'https://dmg.dresden.de/de/unternehmen/kontakt.php',
                'isExternal': true
            },
            'host_area': {
                'title': 'host_area',
                'href': 'https://veranstaltungen-api.dresden.de',
                'isExternal': true
            },
        },
    },
    'images': {
        'logos': {
            'header': '/assets/img/logo/dresden-elbland-logo-weiss.png',
            'footer': {
                'de': '/assets/img/logo/Logo-TMGS-DE-2024.svg',
                'en': '/assets/img/logo/Logo-TMGS-EN-2024.svg'
            }
        },
        'pages': {
            'homepage': '/assets/img/1756_header_detail_large.jpg',
            'events': '/assets/img/1756_header_detail_large.jpg',
            'api': '/assets/img/1756_header_detail_large.jpg',
        },
        'icons': {
            'markerIcons': [
                ['Schlösser', '/assets/img/icons/schloss.png'],
                ['Parks', '/assets/img/icons/park.png'],
                ['Museen', '/assets/img/icons/museum.png'],
                ['Theater', '/assets/img/icons/theater.png'],
                ['Freibäder', '/assets/img/icons/freibad.png'],
                ['Schwimmhallen', '/assets/img/icons/schwimmhalle.png'],
                ['Skateanlagen', '/assets/img/icons/skater.png'],
                ['Kletteranlagen', '/assets/img/icons/kletteranlage.png'],
                ['Tiere Beobachten', '/assets/img/icons/tiere.png'],
                ['Camping', '/assets/img/icons/camping.png'],
                ['Aussichtspunkte', '/assets/img/icons/aussichtspunkte.png'],
                ['Spielplätze', '/assets/img/icons/spielplatz.gif'],
            ],
            'defaultIcon': '/assets/img/icons/marker-icon-green.png'
        }
    },
    'categories': {
        '12': {
            'title': 'Bühne & Musik',
            'icon': 'icon icon-cat-buehne'
        },
        '13': {
            'title': 'Museen & Galerien',
            'icon': 'icon icon-cat-museen'
        },
        '14': {
            'title': 'Party & Tanz',
            'icon': 'icon icon-cat-party'
        },
        '15': {
            'title': 'Kino & Film',
            'icon': 'icon icon-cat-kino'
        },
        '16': {
            'title': 'Feste, Märkte & Spaß',
            'icon': 'icon icon-cat-feste'
        },
        '17': {
            'title': 'Sport & Aktiv',
            'icon': 'icon icon-cat-sport'
        },
        '18': {
            'title': 'Bildung, Info & Kirche',
            'icon': 'icon icon-cat-bildung'
        },
        '19': {
            'title': 'Kongresse, Messe & Wirtschaft',
            'icon': 'icon icon-cat-kongresse'
        },
        '20': {
            'title': 'Stadtrundfahrten & Führungen',
            'icon': 'icon icon-cat-bildung'
        },
        '22': {
            'title': 'Sommer der offenen Weingüter 2020',
            'icon': 'icon icon-cat-feste'
        },
    },
    'breakpoints': {
        'sm': 576,
        'md': 768,
        'lg': 992,
        'xl': 1200,
        'xxl': 1400,
    }
};

export default config;
